import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

//i18n
import { withNamespaces } from 'react-i18next';
import { Link } from 'react-router-dom';
import avatar from '../../../assets/images/avatar.png';


const ProfileMenu = (props) => {

   // Declare a new state variable, which we'll call "menu"
   const [menu, setMenu] = useState(false);
  
   const [username, setusername] = useState("Admin");

   useEffect(() => {
           if(localStorage.getItem("authUser"))
           {
               const obj = JSON.parse(localStorage.getItem("authUser"));
               setusername(obj.data.name);
          }
      },[]);

  return (
    <React.Fragment>
        <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block" >
            <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                <img className="rounded-circle header-profile-user" src={avatar} alt="Header Avatar" />
                <span className="d-xl-inline-block ml-2 mr-1">{username}</span>
                <i className="mdi mdi-chevron-down d-xl-inline-block"></i>
            </DropdownToggle>
            <DropdownMenu right>
                <Link to="/logout" className="dropdown-item">
                    <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                    <span>{props.t('Logout')}</span>
                </Link>
            </DropdownMenu>
        </Dropdown>
    </React.Fragment>
  );
}

export default withNamespaces()(ProfileMenu);
